<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="6">
          <div
            class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
            <label class="vs-input--label">License Plate<sup>*</sup></label>
            <div class="vs-con-input">
              <input
                type="text"
                disabled
                v-model="license_plate"
                name="license_plate"
                class="vs-inputx vs-input--input normal"
                style="border: 1px solid rgba(0, 0, 0, 0.2)" />
            </div>
            <span></span>
          </div>
          <div
            class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
            <label class="vs-input--label">Simcard Number<sup>*</sup></label>
            <div class="vs-con-input">
              <input
                type="text"
                disabled
                v-model="simcard_number"
                name="license_plate"
                class="vs-inputx vs-input--input normal"
                style="border: 1px solid rgba(0, 0, 0, 0.2)" />
            </div>
            <span></span>
          </div>
          <!--<vs-input label="Vehicle Color" name="vehicle_color" v-model="vehicle_color" class="mb-5 w-full" />-->
          <div
            class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
            <label class="vs-input--label">Command<sup>*</sup></label>
            <v-select
              @input="(x) => (command = x.value)"
              :clearable="false"
              :value="getSelectValue(command, command_array)"
              :reduce="(label) => label.value"
              :options="command_array" />
          </div>
        </vs-col>
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="6">
          <div
            class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
            <label class="vs-input--label">Syntax <sup>*</sup></label>
            <vs-textarea v-model="syntax" />
          </div>
          <div
            class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
            <label class="vs-input--label"
              >Immobilize Reason <sup>*</sup></label
            >
            <vs-textarea v-model="reason" />
          </div>
          <!--<vs-input label="Driver Name" name="driver_name" v-model="driver_name" class="mb-5 w-full" />-->
        </vs-col>
      </vs-row>
      <div style="text-align: right">
        <vs-button
          style="margin-left: 16px"
          class="mr-3 mb-2 btn-load-1 btn-submit vs-con-loading__container"
          @click="submit()"
          :disabled="!syntax || !reason"
          >Submit Command
        </vs-button>
      </div>
      <vs-divider></vs-divider>
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :data="data">
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <!-- ITEMS PER PAGE -->
          <h4>Immobilization History</h4>
        </div>
        <template slot="thead">
          <vs-th sort-key="no">NO</vs-th>
          <vs-th sort-key="id">COMMAND</vs-th>
          <vs-th sort-key="alert_name">SYNTAX</vs-th>
          <vs-th sort-key="alert_name">REASON</vs-th>
          <vs-th sort-key="created_by">CREATED BY</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].indextr">
                <p>{{ indextr + 1 }}</p>
              </vs-td>
              <vs-td :data="data[indextr].commands">
                <p class="product-name font-medium">{{ tr.commands }}</p>
              </vs-td>
              <vs-td :data="data[indextr].syntax">
                <p class="product-name font-medium">{{ tr.syntax }}</p>
              </vs-td>
              <vs-td :data="data[indextr].reason">
                <p class="product-name font-medium">{{ tr.reason }}</p>
              </vs-td>

              <vs-td :data="data[indextr].created_by">
                <p class="product-name">{{ tr.created_by }}</p>
              </vs-td>

              <!--<vs-td>-->
              <!--<vs-chip :color="getStatusColor(tr.status)" class="product-order-status">-->
              <!--{{ statusDescription(tr.status) }}-->
              <!--</vs-chip>-->
              <!--</vs-td>-->
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>

    <!--<vs-button class="mr-3 mb-2" @click="submitForm" >Get Data</vs-button>-->
  </div>
</template>

<script>
import * as REPO from '../../repository/index'

import * as moment from 'moment'

export default {
  props: {
    simcard_number: String,
    vehicle_id: String,
    license_plate: String,
  },
  components: {},
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  data() {
    return {
      data: [],
      id: '',
      itemsPerPage: 10,
      syntax: '',
      reason: '',
      command_array: [
        {
          label: 'Immobilizer',
          value: 'Immobilizer',
        },
        {
          label: 'Odometer',
          value: 'Odometer',
        },
      ],
      command: 'Immobilizer',
    }
  },
  watch: {},
  created() {
    var self = this
  },
  beforeDestroy() {
    // REPO.unsubscribeVehicle(this.$route.params.id);
    //
  },
  methods: {
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    getData() {
      if (this.vehicle_id) {
        REPO.getImo(this.vehicle_id)
          .then((res) => {
            this.data = res.data.data
          })
          .catch((err) => {
            //
          })
      }
    },
    submit() {
      let datanya = {
        vehicle_id: this.vehicle_id,
        license_plate: this.license_plate,
        commands: this.command,
        syntax: this.syntax,
        reason: this.reason,
        created_by: this.$dataLocal.UserData().name,
      }

      this.loadingBtnStart('btn-load-1')
      REPO.postImo(datanya)
        .then((res) => {
          this.getData()
          this.syntax = ''
          this.reason = ''
          this.loadingBtnStop('btn-load-1')
          this.$toast.success('Immobilize command Successfully Submitted')
        })
        .catch((err) => {
          this.loadingBtnStop('btn-load-1')
          //
          this.$toast.error(err.message)
        })
    },
  },

  mounted() {
    this.getData()
  },
}
</script>
